__turbopack_context__.v({
  "variantContainer": "RadioButtonTypeAddonGroup-module-scss-module__KaDqkW__variantContainer",
});
